exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-color[data-v-49513653]{border-color:var(--systemMainColor)}.main-color[data-v-49513653]{background-color:var(--systemMainColor);color:var(--colorLumpText)}", ""]);

// exports
